<template>
  <b-overlay rounded="sm" :show="loading">
    <AuthWrapper>
      <template #card>
        <div class="text-center">
          <div>
            <h2>PENT ACCESS CONTROL</h2>
          </div>

          <div class="my-4">
            <h1>Email Verification</h1>
          </div>
        </div>

        <b-alert variant="danger" :show="!!error" class="mb-2">
          <div class="alert-body font-small-2 d-flex align-items-start">
            <feather-icon icon="AlertCircleIcon" class="mr-50 mt-25 flex-shrink-0" />
            <small>{{ error }}</small>
          </div>
        </b-alert>

        <div class="d-flex justify-content-center my-5">
          <b-button @click="$router.push({ name: 'home' })">Go Home</b-button>
        </div>
      </template>
    </AuthWrapper>
  </b-overlay>
</template>

<script>
import { get } from "lodash";
import { required } from "@validations";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import {
  BCol,
  BImg,
  BRow,
  BLink,
  BForm,
  BAlert,
  BButton,
  BOverlay,
  VBTooltip,
  BCardTitle,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BFormCheckbox,
  BInputGroupAppend,
} from "bootstrap-vue";

import TurtleRentLogo from "@core/layouts/components/Logo.vue";
import AuthWrapper from "@core/components/auth-wrapper/AuthWrapper.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import BottomDesign from "@/assets/svg/BottomDesign.svg";
import RegistrationMail from "@/assets/svg/RegistrationMail.svg";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BCol,
    BImg,
    BRow,
    BLink,
    BForm,
    BAlert,
    BButton,
    BOverlay,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BInputGroup,
    AuthWrapper,
    BFormCheckbox,
    RegistrationMail,
    BInputGroupAppend,
    BottomDesign,
    TurtleRentLogo,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
      error: "",
      required,
    };
  },
  created() {
    const { token } = this.$route.query;
    if (token) {
      this.confirmAccount(token);
    } else {
      this.$router.push({
        name: "home",
      })
    }
  },
  methods: {
    async confirmAccount(confirmAccountToken) {
      try {
        this.loading = true;

        await this.useJwt().mainService.auth.verifyEmail(confirmAccountToken);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "CoffeeIcon",
            variant: "success",
            text: "Your email has been verified successfully.",
          },
        });

        this.$router.push({ name: "auth-update-profile-account" });
      } catch (error) {
        const default_error_message = "Your account confirmation token has expired. Please request another one.";
        const error_message =
          get(error, "response.data.message", default_error_message) || error.message;

        this.error = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "CoffeeIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

sup {
  font-size: 1rem;
}
</style>
